import { Tooltip } from '@mantine/core'

import type {
  RevisionMarkOption,
  RevisionsState,
} from '#choo-app/lib/editor/plugins/revisions'

import { RevisionPill } from './RevisionPill'

import styles from './RevisionsStatus.module.css'

// How many is too many??
const MAX_PEEK = 10

const MARK_OPTION_LABELS: Record<RevisionMarkOption, string> = {
  none: 'Not showing any revision info',
  active: 'Showing only the active revision',
  collated: 'Showing collated revisions',
  all: 'Showing all revisions',
  'all-after-full-draft': 'Showing all revisions since the last full draft',
}

interface Props {
  revisionsState: RevisionsState
}

export function RevisionsStatus(props: Props) {
  'use memo'

  const previous = previousRevisionsToShow(props.revisionsState)

  return (
    <Tooltip label={MARK_OPTION_LABELS[props.revisionsState.markOption]}>
      <div className={styles.stack}>
        {previous.map((revision) => (
          <div
            key={revision.label}
            className={styles.sliver}
            style={{ backgroundColor: revision.pageColor }}
          />
        ))}
        <RevisionPill {...props.revisionsState.revisions.active} />
      </div>
    </Tooltip>
  )
}

function previousRevisionsToShow(revisionsState: RevisionsState) {
  const activeRevisionId = revisionsState.revisions.active.snapshot.id
  return revisionsState.visibleRevisions
    .filter((revision) => revision.snapshot.id !== activeRevisionId)
    .slice(-MAX_PEEK)
}
